import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

const ZoomWrapper = styled.div`
  margin-top: 16px;
  width: 48px;

  user-select: none;
  display: none;

  @media (min-width: ${getBreakpoint('xl')}px) {
    display: block;
  }
`

const ZoomButton = styled.div`
  cursor: pointer;
  display: flex;
  min-height: 48px;
  min-width: 48px;
  padding: 0;
  justify-content: center;
  border: none;
  user-select: none;

  background-color: #ffffff;
  background-position: center;
  background-repeat: no-repeat;

  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.08);
`

const ZoomPlus = styled(ZoomButton)`
  border-bottom: 1px solid #e6e6f0;

  border-radius: 100px 100px 0 0;
`

const ZoomMinus = styled(ZoomButton)`
  border-top: 1px solid transparent;

  border-radius: 0 0 100px 100px;
`

export { ZoomMinus, ZoomPlus, ZoomWrapper }
